
var connectionResponseDeserialiser = require('protocol/connection-response-deserialiser');
var logger = require('util/logger').create('Parsing');

/**
 * Connection response parser. Wraps the connection response deserialiser and takes callbacks for successful and failed
 * parsing of the buffer.
 *
 * @param {Function} onHandshakeSuccess - On success callback
 * @param {Function} onHandshakeError - On failure callback
 * @param {Function} message - The buffer to parse
 * @returns {object} - The parsed response or null if parsing failed
 */
function parseResponse(onHandshakeSuccess, onHandshakeError, message) {
    logger.trace('Received connection handshake response');
    var response;

    try {
        response = connectionResponseDeserialiser(message);
    } catch (e) {
        onHandshakeError(e);
        return null;
    }

    return onHandshakeSuccess(response);
}

module.exports = {
    connectionResponse : parseResponse
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/transports/parsing.js
// module id = 1054
// module chunks = 1